import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { ToastService } from '../services/toast.service';
import { APP_PATHS } from '@core/constants/platform-config.constants';
import { catchError, map } from 'rxjs';
import { of } from 'rxjs';

/**
 * Guard to check if the user's status is ACTIVE.
 * If the user status is INACTIVE or any error occurs, the user is logged out,
 * redirected to login, and an error toast is shown.
 */
export const userStatusGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const toastService = inject(ToastService);

  return authService.getUserProfile().pipe(
    map((response) => {
      const userProfile = response.body?.data?.[0];
      const userStatus = userProfile?.status;

      if (userStatus === 'ACTIVE') {
        return true;
      } else {
        // User is inactive, logout and redirect
        authService.logout();
        router.navigateByUrl(`/${APP_PATHS.LOGIN}`);
        toastService.showError('Unauthorised access', 'Your account is inactive. Please contact your administrator.');
        return false;
      }
    }),
    catchError(() => {
      // Error occurred while fetching profile, logout and redirect
      authService.logout();
      router.navigateByUrl(`/${APP_PATHS.LOGIN}`);
      toastService.showError('Unauthorised access', 'Unable to verify your account status. Please login again.');
      return of(false);
    })
  );
};
